import React, { useContext, useEffect, useState } from "react";
import { Card, Container, Form, Button } from "react-bootstrap";

// import Cotter from "cotter";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import authService from "../services/authService";
import { GlobalContext } from "../utility/GlobalContext";

export default function Login(props) {
  const { state, setState } = useContext(GlobalContext);
  const urlParams = new URLSearchParams(window.location.search);
  const loginType = urlParams.get("type");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
  }, []);

  const login = (e) => {
    e.preventDefault();
    console.log("logging in")
    authService
      .login(email, password, loginType)
      .then((response) => {
        console.log(response.data);
        toast.success("Logged in");
        setState({
          user: response.data.user,
          jwt: response.data.token,
          currentUserID: response.data.user.id,
        });
        localStorage.setItem("id_token", response.data.token);
        props.history.push("/");
      })
      .catch((err) => toast.error("Login failed"));
  };

  return (
    <Container
      style={{ backgroundColor: "#d3d3d3", marginTop: 20, padding: 30 }}
    >
      <h4>Login/Signup</h4>
      <Form>
        <div className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            onChange={(e) => setEmail(e.target.value)}
            id="email"
            type="email"
            placeholder="user@website.com"
          />
        </div>
        <div className="mb-3">
          <Form.Label>Password</Form.Label>
          <Form.Control
            onChange={(e) => setPassword(e.target.value)}
            id="link"
            type="password"
            // placeholder="mywebsite.com"
          />
        </div>
        <Button
          onClick={login}
          variant="primary"
          type="submit"
          className="col-lg-4"
        >
          Submit
        </Button>
      </Form>
    </Container>
  );
}
